<header class="mast-main-head fixed-top" *ngIf="mobileViewSection">
  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container left-header-subscribe">
      <a class="navbar-brand js-scroll-trigger" routerLink="/home"><img src="assets/img/logo.svg"></a>
    </div>
  </nav>
</header>

<header class="masthead" *ngIf="!mobileViewSection">

  <div class="main-header-subscriber-offer-section ai-header-back">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right-green.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div>

	<div class="navbar ai-header-back">
		<div class="left-header" style="margin-left: 12px; position: relative">
      <a class="navbar-brand js-scroll-trigger" routerLink="/home"><img src="assets/img/logo.svg"></a>
      <div class="lib-icon-blue">
        <img src="assets/img/ic-ai.svg">
      </div>
      <div class="lib-icon-blue" style="cursor: pointer; margin-left: 12px;" (click)="goToWorkspace()" mat-raised-button #tooltip="matTooltip"
        matTooltip="Workspace"
        matTooltipPosition="below"
        matTooltipClass="custom-tooltip">
        <img src="assets/img/workspace.svg">
      </div>
		</div>

		<div class="right-header">
      <div class="menu-pop-over anticon-bell">
				<a href="javascript:;" class="upgrade-txt" (click)="showUpgradePlans()" *ngIf="userRole == 'Owner' || userRole == 'Admin'">Upgrade</a>
			</div>

			<div class="figma-icons-section">
        <div class="plugin-figma-icon">
          <button (click)="openFigma()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-figma.png">
          </button>
        </div>

        <div class="plugin-sketch-icon">
          <button (click)="openSketch()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-sketch.png">
          </button>
        </div>

        <div class="plugin-ai-icon">
          <button (click)="openIllustrator()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ai.png" style="width: 20px; height: 20px;">
          </button>
        </div>
      </div>

			<div class="menu-pop-over anticon-bell">
				<button id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon" (click)="getNotifications()">
					<img src="assets/img/ic-noti.svg">
				</button>
				<!-- <span class="dot"></span> -->
				<div class="dropdown-menu notification-area" aria-labelledby="notification-pop-over">
						<div class="dropdown-container">
							<h5 class="notification-txt" style="margin-bottom:20px;"><b>Notifications</b></h5>
							<div class="notification-item">

								<div *ngIf="notifications.length == 0" class="empty-notification-area">
									<img src="assets/img/no-noti.svg" alt="">
									<span>You have no notifications</span>
								</div>

								<ul *ngFor="let noti of notifications" style="padding: 0px;">
									<li style="border-bottom: 1px solid rgba(0,0,0,0.1);padding: 16px 0 16px 0;margin: 0 16px;">
										<div class="user-details-info">
										<div class="user-img">
											<span class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon" style="width: 40px; height: 40px; line-height: 40px; font-size:18px; font-weight: 500;">
												<div class="email-initial-setup" [style.background-color]="getRandomColor()">
													{{getName(noti.firstName)}}{{getName(noti.lastName)}}
												</div>
											</span>
										</div>
										<div>
											<div class="user-info-name">
												<span>{{noti.message}} <b>{{noti.firstName}} {{noti.lastName}}</b></span>
											</div>
											<div class="" style="margin-top: 4px;">
												<span class="notification-date">{{noti.timestamp.toString().split(".")[0]}}</span>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<div class="menu-pop-over user-name" *ngIf="currentUser  && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
					<img *ngIf="!userPic" src="assets/img/user-profile.svg">
					<img *ngIf="userPic" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
								<span class="pro">
									{{planName}}
								</span>
							</div>
							<div class="email">{{currentUser.email}}</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed <= 1000" class="storage-size">{{consumedSpaceAllowed | number: '1.2-2'}}MB / {{totalSpaceAllowed}}GB</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed}}GB</div>
							<div *ngIf="totalSpaceAllowed > 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed/1000}}TB</div>
							<progress id="file" value="{{consumedSpaceAllowed}}" max="{{totalSpaceAllowedProgress}}"></progress>
						</div>

						<ul class="dropdown-list list-group">
							<div class="hr-line"></div>
							<a routerLink="/my-profile"><li class="list-group-item">My profile</li></a>
							<a (click)="personalClick()"><li class="list-group-item">My content hub</li></a>
							<div class="hr-line"></div>
							<a routerLink="/how-it-works" target="_blank"><li class="list-group-item">How it works</li></a>
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a (click)="goToFeedback()"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
              <a (click)="goProClick()" *ngIf="planName == 'Free'">
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
						<div class="logout-btn">
							<button type="button" class="ant-btn" (click)="logOut()"><a>Logout</a></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<section class="toast-section" *ngIf="mobileViewSection">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 toast-area">
        <span>Crafttor Workspace is best experienced on desktop. To proceed, Log in from a desktop browser.</span>
      </div>
    </div>
  </div>
</section>

<section class="ai-artist-main-section">
	<div class="container">
		<div class="row">
      <div class="col-sm-7 ai-search-fields">
        <h2>Unleash your imagination <br><span class="with-ai">WITH AI</span></h2>
        <p>Experience the power of AI-generated images with Crafttor. From abstract art to realistic landscapes, Crafttor enables you to easily create stunning visuals that are entirely unique.</p>
        <div class="ai-artist-prompt-section">

          <div class="inner-content">
            <input type="text" [(ngModel)]="prompt" placeholder="Describe your image" />
            <button class="ai-img-generate-btn" (click)="generateTextToImage()">
              <i class="fa fa-magic"></i>
            </button>

            <label style="margin-bottom: 0px;" class="ai-img-generate-btn">
              <input type="file" (change)="onImageChange($event)" multiple />
              <i class="fa fa-upload"></i>
            </label>
          </div>

          <div class="upload-section">
            <button class="ai-img-generate-btn" (click)="generateImageToImage()">
              <i class="fa fa-upload"></i>
            </button>
            <!-- <span *ngIf="uploadedFileName" class="upload-status">Uploaded: {{ uploadedFileName }}</span> -->

            <div class="thumbnail-preview">
              <img *ngFor="let img of base64Images" [src]="img" height="100" width="100" />
            </div>
          </div>
        </div>
			</div>

      <div class="col-sm-5">
				<div class="img-boxes">
					<img src="assets/img/work-hero.png" alt="download gif illustration">
				</div>
			</div>
		</div>
	</div>
</section>

<section class="ai-artist-main-section">
  <div class="container">
    <div class="row">
      <ul>
        <li>

        </li>
      </ul>
      <img *ngIf="generatedImage" [src]="generatedImage" width="300" />
    </div>
  </div>
</section>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:100px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':workspaceListStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: auto;
    width: 40%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<button style="text-align: end;" type="button" class="close" (click)="closeWorkspaceListDialog()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg" alt="download free illustrations">
			</button>
			<div class="modal-body move-top-dialog">
				<h5>Move To</h5>
				<p>The assets moved from current board will appear on a new(selected) board.</p>
				<!-- <form class="custom-form search-area-field ant-input-search-field" (ngSubmit)="onSearchBoards()" #heroForm="ngForm">
  				<input placeholder="Search Boards" data-test-name="invite-email-input" class="ant-input-search-field-section" type="text" value="" name="boardSearchKeyword" [(ngModel)]="boardSearchKeyword" required>
  				<input style="display: none" type="Submit" class="button">
				</form> -->
				<!-- <img *ngIf="showTopRightLoader" class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt=""> -->
				<h6 *ngIf="workspaces.length == 0" style="text-align: center;">No Workspace found</h6>
				<h6 *ngIf="workspaces.length > 0">Workspaces</h6>
				<div class="button-wrapper move-to-board" *ngIf="workspaces.length > 0">
					<div class="">
						<ul class="list-group select-board-to-move" *ngFor="let workspacelist of workspaces | slice:0:10">
							<li class="select-board-to-move" (click)="openBoardsListDialog(workspacelist.id)">
  					 		<span class="board-name-btn">{{ workspacelist.title }}</span>
  					 		<i class="fa fa-plus plus-icons"></i>
				 			</li>
						</ul>
					</div>
			 	</div>
			</div>
		</div>
	</div>
</div>
